function hasUserId(stats) {
  const userId = stats?.user?.id;
  return userId !== undefined && userId !== null && userId !== "";
}

function isEligibleAdmin(stats) {
  return (
    stats?.type === "internal" &&
    stats?.permissions?.admin === true &&
    hasUserId(stats)
  );
}

function getChangelogDismissalKey(version, userId) {
  return `casp.admin.changelog.dismissed.${version}.${String(userId)}`;
}

function hasDismissedChangelog(storage, key) {
  if (!storage || !key) return false;
  try {
    return storage.getItem(key) === "true";
  } catch (_error) {
    return false;
  }
}

function dismissChangelog(storage, key) {
  if (!storage || !key) return false;
  try {
    storage.setItem(key, "true");
    return true;
  } catch (_error) {
    return false;
  }
}

function shouldShowAdminChangelog(stats, version, storage) {
  if (!isEligibleAdmin(stats)) return false;
  const key = getChangelogDismissalKey(version, stats.user.id);
  return !hasDismissedChangelog(storage, key);
}

module.exports = {
  dismissChangelog,
  getChangelogDismissalKey,
  hasDismissedChangelog,
  isEligibleAdmin,
  shouldShowAdminChangelog,
};
